import React from 'react';
import { Helmet } from 'react-helmet';

const AboutUsMetaTag = () => {
  return (
    <Helmet>
        <meta charset="UTF-8" />
       <meta name="description" content="StepMint revolutionizes the earn by walking concept where users get paid to complete their daily walking tasks." />
        <meta name="title" content="walk for money app|walk and get paid|earn by walking" />
        <meta name="keywords" content="Earn MrMint Token for your steps, walk for money app, walk and get paid, earn by walking, rewards for walking" />
        <title>walk for money app|walk and get paid|earn by walking</title>
      {/* Organization JSON-LD */}
      <script type="application/ld+json">
        {`
        {
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "StepMint",
          "alternateName": "StepMint",
          "url": "https://stepmint.io/",
          "logo": "https://stepmint.io/assets/images/logo.png",
          "sameAs": [
            "https://www.facebook.com/profile.php?id=61551542573562",
            "https://twitter.com/step_mint",
            "https://instagram.com/stepmint?igshid=MzMyNGUyNmU2YQ==",
            "https://www.linkedin.com/company/stepmint/about/?viewAsMember=true"
          ]
        }
        `}
      </script>

      {/* Website JSON-LD */}
      <script type="application/ld+json">
        {`
        {
          "@context": "https://schema.org/",
          "@type": "WebSite",
          "name": "StepMint",
          "url": "https://stepmint.io/",
          "potentialAction": {
            "@type": "SearchAction",
            "target": "{search_term_string}",
            "query-input": "required name=search_term_string"
          }
        }
        `}
      </script>

      {/* Meta Tags */}
      <meta property="og:type" content="business.business" />
      <meta property="og:title" content="walk for money app|walk and get paid|earn by walking" />
      <meta property="og:url" content="https://stepmint.io/aboutus" />
      <meta property="og:image" content="https://stepmint.io/assets/images/woman-stretching-leg.png" />
      <meta property="og:description" content="StepMint revolutionizes the earn by walking concept where users get paid to complete their daily walking tasks." />
      <meta property="business:contact_data:street_address" content="322, Magneto Offizo, Magneto Mall" />
      <meta property="business:contact_data:locality" content="raipur" />
      <meta property="business:contact_data:region" content="Chhattisgarh" />
      <meta property="business:contact_data:postal_code" content="492001" />
      <meta property="business:contact_data:country_name" content="India" />

      {/* Website Meta Tags */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content="walk for money app|walk and get paid|earn by walking" />
      <meta property="og:url" content="https://stepmint.io/aboutus" />
      <meta property="og:image" content="https://stepmint.io/assets/images/woman-stretching-leg.png" />
      <meta property="og:description" content="StepMint revolutionizes the earn by walking concept where users get paid to complete their daily walking tasks." />
    </Helmet>
  );
};

export default AboutUsMetaTag;
